import { useTranslation } from 'react-i18next';
import { getPhoneResponse } from '@hero/web-hooks';
import { maskPhoneNumber } from '@hero/web-utils';
import OtpForm from '@/components/features/Auth/OtpForm';
import RegistrationBox from '@/components/features/Auth/RegistrationBox';

export default function RegisterVerifyNum() {
  const { t } = useTranslation(['registration']);
  const phone = getPhoneResponse().at(-1)?.phone;

  return (
    <RegistrationBox
      img={'/images/logos/hero-logo-small.svg'}
      title={t('otp.title')}
      desc={t('otp.subTitle')}>
      {phone && (
        <p className="text-base text-gray-500 text-center mb-6" dir="ltr">
          {maskPhoneNumber(phone)}
        </p>
      )}

      <OtpForm />
    </RegistrationBox>
  );
}
